export const SecureIcon = ({ width, height }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={width}
        height={height}
        x="0"
        y="0"
        viewBox="0 0 214.27 214.27"
        xmlSpace="preserve"
       
    >
        <g>
            <path
                d="M196.926 55.171c-.11-5.785-.215-11.25-.215-16.537a7.5 7.5 0 0 0-7.5-7.5c-32.075 0-56.496-9.218-76.852-29.01a7.498 7.498 0 0 0-10.457 0c-20.354 19.792-44.771 29.01-76.844 29.01a7.5 7.5 0 0 0-7.5 7.5c0 5.288-.104 10.755-.215 16.541-1.028 53.836-2.436 127.567 87.331 158.682a7.495 7.495 0 0 0 4.912 0c89.774-31.116 88.368-104.849 87.34-158.686zm-89.795 143.641c-76.987-27.967-75.823-89.232-74.79-143.351.062-3.248.122-6.396.164-9.482 30.04-1.268 54.062-10.371 74.626-28.285 20.566 17.914 44.592 27.018 74.634 28.285.042 3.085.102 6.231.164 9.477 1.032 54.121 2.195 115.388-74.798 143.356z"
                fill="#000000"
                opacity="1"
                data-original="#000000"
            ></path>
            <path
                d="m132.958 81.082-36.199 36.197-15.447-15.447a7.501 7.501 0 0 0-10.606 10.607l20.75 20.75a7.477 7.477 0 0 0 5.303 2.196 7.477 7.477 0 0 0 5.303-2.196l41.501-41.5a7.498 7.498 0 0 0 .001-10.606 7.5 7.5 0 0 0-10.606-.001z"
                fill="#000000"
                opacity="1"
                data-original="#000000"
            ></path>
        </g>
    </svg>
);
export const DeactivatIcon = ({ width, height }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width={width}
        height={height}
        x="0"
        y="0"
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        class=""
    >
        <g transform="matrix(1,0,0,1,1.7763568394002505e-15,1.7763568394002505e-15)">
            <g fill="#000">
                <path
                    d="M11.5 24a.497.497 0 0 1-.242-.063C10.88 23.728 2 18.743 2 12.499V1.656a.5.5 0 0 1 .834-.372 5.486 5.486 0 0 0 3.666 1.4c1.848 0 3.562-.92 4.586-2.461a.5.5 0 0 1 .833.001 5.486 5.486 0 0 0 4.583 2.461c1.341 0 2.63-.486 3.635-1.371.221-.236.705-.164.832.164a.517.517 0 0 1 .031.223v10.8c0 6.243-8.88 11.229-9.258 11.438A.517.517 0 0 1 11.5 24zM3 2.663V12.5c0 5.122 7.088 9.584 8.5 10.422 1.411-.838 8.5-5.305 8.5-10.422V2.664a6.494 6.494 0 0 1-3.498 1.021A6.488 6.488 0 0 1 11.5 1.337a6.484 6.484 0 0 1-5 2.348A6.493 6.493 0 0 1 3 2.663z"
                    fill="#000000"
                    opacity="1"
                    data-original="#000000"
                    class=""
                ></path>
                <path
                    d="M14.5 15a.502.502 0 0 1-.354-.146l-6-6a.5.5 0 0 1 .707-.707l6 6A.5.5 0 0 1 14.5 15z"
                    fill="#000000"
                    opacity="1"
                    data-original="#000000"
                    class=""
                ></path>
                <path
                    d="M8.5 15a.5.5 0 0 1-.354-.853l6-6a.5.5 0 0 1 .707.707l-6 6A.498.498 0 0 1 8.5 15z"
                    fill="#000000"
                    opacity="1"
                    data-original="#000000"
                    class=""
                ></path>
            </g>
        </g>
    </svg>
);

export const HomeIcon = ({ width = 56, height = 56 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 56 56"
      fill="none"
    >
      <path
        d="M28 5.333L8 22.667V50.667h12V38.667h16v12h12V22.667L28 5.333Z"
        fill="#000000"
      />
    </svg>
  );

  export const TableFilte = ({ width = 25, height = 25 }) => (
    <svg  width="22" height="22"  viewBox="0 0 512 512"><g><path d="M360 256c0-18.638 12.748-34.299 30-38.74a40.055 40.055 0 0 0-10-1.26h-40c-22.091 0-40 17.909-40 40s17.909 40 40 40h40c3.453 0 6.804-.438 10-1.26-17.252-4.441-30-20.102-30-38.74z"  fill="#cee1f2" data-original="#cee1f2" opacity="0"></path><path d="M20 96h80"  fill="none" stroke="#22419e" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" data-original="#0023c4" opacity="1"></path><path d="M300 96h192"  fill="none" stroke="#22419e" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" data-original="#ff5cf4" opacity="1"></path><path d="M20 256h280M420 256h72M20 416h80M220 416h272M180 136h-40c-22.091 0-40-17.909-40-40s17.909-40 40-40h40c22.091 0 40 17.909 40 40s-17.909 40-40 40zM180 456h-40c-22.091 0-40-17.909-40-40s17.909-40 40-40h40c22.091 0 40 17.909 40 40s-17.909 40-40 40zM380 296h-40c-22.091 0-40-17.909-40-40s17.909-40 40-40h40c22.091 0 40 17.909 40 40s-17.909 40-40 40z"  fill="none" stroke="#22419e" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" data-original="#0023c4" opacity="1"></path></g></svg>
  );

  export const TableReset = ({ width = 25, height = 25 }) => (
    <svg  width="22" height="22" x="0" y="0" viewBox="0 0 24 24"><g><path fill="#22419e" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10c4.356 0 8.058-2.784 9.43-6.667a1 1 0 1 0-1.885-.666A8 8 0 1 1 12 4c1.552 0 2.866.561 4.116 1.44.84.592 1.619 1.301 2.408 2.06H15.5a1 1 0 1 0 0 2H21a1 1 0 0 0 1-1V3a1 1 0 1 0-2 0v3.144c-.848-.818-1.754-1.65-2.733-2.34C15.795 2.77 14.085 2 12 2z" opacity="1" data-original="#1e1e1e"></path></g></svg>
  );


  export const TableColumns = ({ width = 25, height = 25 }) => (
    <svg  version="1.1"  width="22" height="22" x="0" y="0" viewBox="0 0 24 24"><g><path fill="#22419e" fillRule="evenodd" d="M2.879 2.879A3 3 0 0 1 5 2h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 .879-2.121zM13 20h6a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-6zM11 4v16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z" clipRule="evenodd" opacity="1" data-original="#000000"></path></g></svg>
  );
  
  export const NotificationDarkIcon = ({ width, height }) => (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" width={width} height={height} x="0" y="0" viewBox="0 0 512 512" xmlSpace="preserve"><g><linearGradient id="a" x1="256" x2="256" y1="512" y2="2" gradientUnits="userSpaceOnUse"><stop stopOpacity="1" stopColor="#22419e" offset="0"></stop><stop stopOpacity="1" stopColor="#eaf6ff" offset="0.503"></stop><stop stopOpacity="1" stopColor="#22419e" offset="1"></stop></linearGradient><linearGradient id="b" x1="256.001" x2="256.001" y1="452" y2="0" gradientUnits="userSpaceOnUse"><stop stopOpacity="1" stopColor="#1c73b2" offset="0"></stop><stop stopOpacity="1" stopColor="#22419e" offset="0.5656370656370656"></stop></linearGradient><path fill="url(#a)" d="M107.343 28.249c6.212-5.48 6.807-14.958 1.326-21.171C103.19.865 93.71.271 87.497 5.751 32.527 54.238 1 123.946 1 197c0 8.284 6.716 15 15 15s15-6.716 15-15c0-64.449 27.826-125.956 76.343-168.751zm317.16-22.498C418.289.271 408.81.866 403.331 7.078c-5.48 6.213-4.886 15.691 1.326 21.171C453.174 71.044 481 132.551 481 197c0 8.284 6.716 15 15 15s15-6.716 15-15c0-73.054-31.527-142.762-86.497-191.249zM129.138 49.01C85.835 86.179 61 140.119 61 197c0 8.284 6.716 15 15 15s15-6.716 15-15c0-48.12 21.022-93.763 57.677-125.226 6.286-5.396 7.008-14.866 1.612-21.152-5.396-6.287-14.867-7.008-21.151-1.612zm253.724 0c-6.286-5.396-15.756-4.674-21.151 1.612-5.396 6.286-4.674 15.756 1.612 21.152C399.978 103.237 421 148.88 421 197c0 8.284 6.716 15 15 15s15-6.716 15-15c0-56.881-24.835-110.821-68.138-147.99zM286 422h-60c-8.284 0-15 6.716-15 15v30c0 24.813 20.187 45 45 45s45-20.187 45-45v-30c0-8.284-6.716-15-15-15z" opacity="1" data-original="url(#a)"></path><path fill="url(#b)" d="M446.604 426.392C410.747 390.533 391 342.857 391 292.147V197c0-69.369-52.594-126.676-120-134.162V15c0-8.284-6.716-15-15-15s-15 6.716-15 15v47.838C173.594 70.324 121 127.631 121 197v95.147c0 50.71-19.747 98.385-55.604 134.244C56.113 435.667 62.452 452 76 452h360c13.51 0 19.911-16.308 10.604-25.608z" opacity="1" data-original="url(#b)"></path></g></svg>
);